import {
  FAQS,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  REGISTRATION_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LOGO_URL = "https://ss-leagues.s3.amazonaws.com/MLS/austin-fc-logo.png";
const LANDING_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/MLS/Austin%20FC/ut_promo_resized_desktop%201.png";
const MOBILE_LANDING_PAGE_STATIC_BANNER_URL =
  "https://ss-leagues.s3.amazonaws.com/MLS/Austin%20FC/ut_promo_resized_mobile%201.png";

export const austinfc_student: TTeamConfig = {
  TEAM_SCHEMA: "austinfc_student",
  BROWSER_TITLE: "Austin FC Student",
  TEAM_FULL_NAME: "Austin FC",
  VENDOR: constants.vendorUUIDs.seatgeek,
  // SeatGeek FE CLIENT_ID = the client-specific Auth (v2) client id.
  CLIENT_ID: "NDYxNzQ3MTB8MTc5MzgwODk5OS4xMjM5MjYy",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#00B140",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ACCOUNT_MANAGER_URL: "https://seatgeek.com/austinfc/verify",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_PURCHASE_HISTORY: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    // No pass card and no registration box (users register on the Flow URL).
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  IMAGES: {
    LOGO_URL,
    ORDER_SUMMERY_BACKGROUND_URL: LANDING_PAGE_STATIC_BANNER_URL,
    LANDING_PAGE_STATIC_BANNER_URL,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
